// removed by extract-text-webpack-plugin
module.exports = {"republic-insurance-icon-background":"#03666f","republic-insurance-icon-name":"handshake-o","republic-insurance-background":"#037b86"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/carrier.scss
// module id = 2809
// module chunks = 0